import { EvtSelect } from "components/select";
import { getDirectusField } from "directus/src/operations";
import { useFetch } from "hooks/src/useFetch";
import React from "react";

const SelectFor = ({
  collection = "tags",
  className,
  value,
  onChange,
  onValueChange,
  placeholder = "Select For",
  ...props
}) => {
  const { data, isLoading } = useFetch({
    queryKey: [collection, "fields", "for"],
    queryFn: async () => {
      const response = await getDirectusField(collection, "for");
      const choices = response?.meta?.options?.choices || [];
      return choices.map((choice) => ({
        name: choice.text || choice.value,
        id: choice.value,
      }));
    },
    enabled: !!collection,
  });

  return (
    <EvtSelect
      data={data}
      isLoading={isLoading}
      className={className}
      value={value}
      onChange={onChange}
      onValueChange={onValueChange}
      placeholder={placeholder}
      type="filter"
      {...props}
    />
  );
};

export default SelectFor;
